/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import { combineReducers } from 'redux'
import * as types from '../types'

import app from './app'
import user from './user'
import alert from './alert'
import loginned from './loginned'


const appReducer = combineReducers({
  app,
  loginned,
  alert,
  user
})

const rootReducer = (state, action) => {
  if (action.type === types.user.LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer
